import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BookingService } from '@clooper/core';
import { faEnvelope, faLocation, faPhone, faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-contact-support',
  templateUrl: './contact-support.component.html',
  styleUrls: ['./contact-support.component.scss']
})
export class ContactSupportComponent implements OnInit {
contactForm: FormGroup
  icons = {
    address: faLocation,
    phone: faPhone,
    mail: faEnvelope,
    cancel: faTimes
  }
  requestSent = false;
  showNextDisplay = false
  loading = false;

  constructor(
    public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private service: BookingService
  ) { }

  ngOnInit(): void {
    this.contactForm = this.fb.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
    })
  }


  submit() {
    this.loading = true
    this.service.contactSupport(this.contactForm.value).subscribe((res: any) => {
      if (res) {
        this.loading = false
        this.requestSent = false;
        this.showNextDisplay = true
      }
    })
  }

}
